import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import NotFound from './pages/NotFound';
import Dashboard from './pages/Dashboard';
import Login from "./partials/Login";
import Register from "./partials/Register";
import Society from "./pages/Society";
import Staff from "./pages/Staff";
import Profile from "./pages/Profile";
import Profil from "./pages/Profil";
import Vehicle from "./pages/Vehicle";
import Coli from "./pages/Coli";
import Invoice from "./pages/Invoice";
import Home from "./pages/Home";
import Manifeste from "./pages/Manifeste";
import ManifesteDetail from "./pages/ManifesteDetail";
import Solde from "./pages/Solde";
import Depense from "./pages/Depense";
import Report from "./pages/Report";
import Contact from "./pages/Contact";
import Expedition from "./pages/Expedition";
import Facture from "./pages/Facture";
import Recu from "./pages/Recu";
import RecuDetail from "./pages/RecuDetail";
import Client from "./pages/Client";
import Budget from "./pages/Budget";
import Litige from "./pages/Litige";
 
function handleCheck(permissions, val) {
    return  (permissions ?? []).some(item => val === item.name);
}

function RouterPage({ user = null, permissions = [] }){

    return(
        <Switch>
            <Route exact path="/" component={ Home } />
            
            <Route path="/register" component={Register} />
            <Route path="/login" component={Login} />
            {
                handleCheck(permissions, "afficher dashboard") == true && (
                    <Route path="/dashboard" component={Dashboard} />
                )
            }

            {
                handleCheck(permissions, "configurer branche") == true && (
                    <Route path="/settings" component={Society} />
                )
            }
            
            {
                handleCheck(permissions, "afficher utilisateur") == true && (
                    <Route path="/staffs" component={Staff} />
                )
            }

            {
                handleCheck(permissions, "afficher client") == true && (
                    <Route path="/clients" component={ Client} />
                )
            }

            {
                handleCheck(permissions, "afficher vehicule") == true && (
                    <Route path="/vehicles" component={Vehicle} />
                )
            }

            {
                handleCheck(permissions, "afficher coli") == true && (
                    <Route path="/colis" component={Coli} />
                )
            }

            {
                handleCheck(permissions, "afficher facture") == true && (
                    <Route path="/invoices" component={ Invoice } />
                )
            }

            {
                handleCheck(permissions, "afficher manifeste") == true && (
                    <Route path="/manifestes/:id" component={ ManifesteDetail } />
                )
            }

            {
                handleCheck(permissions, "afficher manifeste") == true && (
                    <Route path="/manifestes" component={ Manifeste } />
                )
            }

            {
                handleCheck(permissions, "afficher profil") == true && (
                    <Route path="/profiles" component={Profil} />
                )
            }

            {
                handleCheck(permissions, "afficher solde") == true && (
                    <Route path="/soldes" component={Solde} />
                )
            }

            {
                handleCheck(permissions, "afficher rapport") == true && (
                    <Route path="/reports" component={Report} />
                )
            }

            {
                handleCheck(permissions, "afficher depense") == true && (
                    <Route path="/depenses" component={ Depense } />
                )
            }

            {
                handleCheck(permissions, "afficher mes expeditions") == true && (
                    <Route path="/expeditions/:id" component={ ManifesteDetail } />
                )
            }
            {
                handleCheck(permissions, "afficher mes expeditions") == true && (
                    <Route path="/expeditions" component={ Expedition } />
                )
            }

            {
                handleCheck(permissions, "afficher mes factures") == true && (
                    <Route path="/factures" component={ Facture } />
                )
            }

            <Route exact path="/recus/:id" component={ RecuDetail } />

            {
                handleCheck(permissions, "afficher mes recus") == true && (
                    <Route exact path="/recus" component={ Recu } />
                )
            }

            {
                handleCheck(permissions, "afficher manifeste") == true && (
                    <Route path="/budgets" component={ Budget } />
                )
            }

            {
                handleCheck(permissions, "afficher facture") == true && (
                    <Route path="/litiges" component={ Litige } />
                )
            }
            
            <Route path="/profile/:id" component={Profile} />
            <Route path="/profile" component={Profile} />
            <Route path="/contacts" component={ Contact } />
            
            {user ? <Route component={NotFound} /> : <Redirect to="/login" />}
        </Switch>
    )
}

export default RouterPage;
